import React from "react";

function Section3() {
  return (
    <section className="csrd-section-3-container">
      <div className="csrd-section-3-inner-container">
        <div className="left-section-3">
          <div className="left-section-3-inner-container">
            <div className="blue-background"></div>
            <h2 className="section-3-heading">Reporting</h2>
            <p className="section-3-description">
              <div>Structured CSRD reports formatted as per ESRS disclosure requirements.</div>
              <div>Provides insights into alignment with other ESG frameworks.</div>
              <div>Generate CSRD reports in multiple formats, including XBRL, PDF, and HTML.</div>
            </p>
          </div>
        </div>
        <div className="right-section-3">
          <div className="right-section-3-inner-container">
            <img
              src={require("../../../../assets/Solution/csrd/reporting.svg")}
              className="img3"
              alt="reporting"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section3;
